import React, { ReactNode, Component } from "react";
import {
	TextInput,
	View,
	Text,
	Image,
	TextInputProps,
	Platform,
	TouchableWithoutFeedback,
	NativeSyntheticEvent,
	TextInputFocusEventData,
} from "react-native";
import debounce from "lodash.debounce";
import styles from "../styles";
import theme from "../theme";
import { dynamicSize } from "../helpers";
import { OnInputChange, IFormField, IFormInputCustomProps } from "../base/models/forms";
import { FormField } from "../base/form-validation";

const iconCorrect = require("../assets/images/icons/icon-correct.png");
const iconIncorrect = require("../assets/images/icons/icon-incorrect.png");

// type FormInputProps = {
// 	// placeholder?:string;
// 	// value?:any;
// 	// secureTextEntry;
// 	// autoCorrect;
// 	// autoCapitalize;
// 	// keyboardType;
// 	border?: number;
// 	label?: string;
// 	// onChange;
// 	showIcon?: boolean;
// 	isCorrect?: boolean;
// 	field?: IFormField;
// 	onInputChange?: OnInputChange;
// 	onBlur?: (field: IFormField) => any;
// 	invalid?: boolean;
// 	// multiline;
// 	// style;
// };

type FormInputFullProps = TextInputProps & {
	customProps?: IFormInputCustomProps;
	children?: ReactNode;
	formField?: FormField & any;
};

export default class FormInput extends Component<FormInputFullProps> {
	private inputEl;
	private readonly onChange = debounce(
		(text: string) => {
			if (this.props.customProps && this.props.customProps?.onInputChange)
				this.props.customProps?.onInputChange(this.props.customProps?.field, text);
		},
		500,
		{
			leading: false,
			trailing: true,
		}
	);

	render() {
		const { formField, children, customProps, defaultValue, ...rest } = this.props;
		const defaultValue1: string = (defaultValue || "").toString();
		console.log("FormInput:", customProps?.field?.id, this.props);
		const webStyles = {
			...Platform.select({
				web: {
					// bottomBottomColor: customProps.isCorrect ? "pink" : theme.errorColor, // 747980 // sheri
					borderBottomWidth: 1,
					// paddingLeft: dynamicSize(5),
					// paddingRight: dynamicSize(5),
				},
			}),
		};

		let isTextarea: boolean = this.props.multiline || customProps?.field?.fieldType === "textarea";
		const invalidStyles = customProps?.invalid ? styles.form.invalidInput : {};
		let inputStyle: any = [
			styles.text.formInput,
			styles.form.input,
			{
				borderBottomWidth: customProps?.border ? 1 : 0,
				paddingRight: customProps?.showIcon ? dynamicSize(22) : 0,
				marginTop: dynamicSize(3),
			},
			webStyles,
			invalidStyles,
		];
		if (isTextarea) {
			inputStyle = [styles.text.formInput, styles.form.textarea, webStyles, invalidStyles];
		}
		return (
			<View style={styles.form.group} nativeID={"laco-form-input-" + customProps?.field?.id}>
				{customProps?.label && (
					<TouchableWithoutFeedback
						onPress={() => {
							if (this.inputEl) this.inputEl.focus();
						}}
					>
						<Text
							style={[styles.text.formLabel]}
							nativeID={"laco-form-input-label-" + customProps?.field?.id}
						>
							{customProps?.label.toUpperCase()}
							{customProps?.showAsterisks && customProps?.asteriskTemplate}
						</Text>
					</TouchableWithoutFeedback>
				)}
				<TextInput
					nativeID={"laco-form-input-text-" + customProps?.field?.id}
					style={inputStyle}
					ref={(component) => (this.inputEl = component)}
					// autoCorrect={true}
					// placeholder={placeholder}
					placeholderTextColor={theme.colors.grey4}
					// autoCapitalize={autoCapitalize}
					keyboardType={this.props.keyboardType || "default"}
					// secureTextEntry={secureTextEntry}
					multiline={isTextarea}
					selectionColor={theme.colors.orange}
					underlineColorAndroid="transparent"
					numberOfLines={10}
					textContentType={customProps?.field?.fieldType === "email" ? "emailAddress" : "none"}
					editable={customProps?.enabled}
					onChangeText={(text: string) => {
						this.onChange(text);
						// if (customProps.onInputChange) {
						// 	customProps.onInputChange(customProps.field, text);
						// }
					}}
					onBlur={(e: NativeSyntheticEvent<TextInputFocusEventData>) => {
						if (customProps?.onBlur) {
							customProps?.onBlur(customProps?.field);
						}
					}}
					{...rest}
					defaultValue={defaultValue1}
					// value={(this.props.formField?.value || "").toString()}
				/>
				{customProps?.showIcon && (
					<Image style={styles.form.icon} source={customProps?.isCorrect ? iconCorrect : iconIncorrect} />
				)}
			</View>
		);
	}
}
